import { render, staticRenderFns } from "./MaterialDetection.vue?vue&type=template&id=f5dbc08a&scoped=true&"
import script from "./MaterialDetection.vue?vue&type=script&lang=js&"
export * from "./MaterialDetection.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetection.vue?vue&type=style&index=0&id=f5dbc08a&scoped=true&lang=css&"
import style1 from "./MaterialDetection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dbc08a",
  null
  
)

export default component.exports